import React from 'react';
import { Box } from '@quintoandar-tokko/jopijs';
import styles from './pendingContact.module.scss';
import PendingContactCard from './PendingContactCard';
import { showCardSeparator } from '../utils';

function PendingContactContainer({ pendingContacts, trackCallback = null }) {
  return (
    <Box className={styles.pendingContactContainer}>
      {pendingContacts.map((contact, index) => (
        <Box key={contact.id}>
          <PendingContactCard contact={contact} trackCallback={trackCallback} />
          {showCardSeparator(index, pendingContacts) && (
            <Box className={styles.separator} />
          )}
        </Box>
      ))}
    </Box>
  );
}

export default PendingContactContainer;
